import axios from 'axios';

export default {
	state: () => ({
		apiUrl: '/api/hcp-portal/search-hcp',
		originHcps: [],
		hcps: [],
		sortedHcps: [],
		paginatedHcps: [],
		isEmpty: false,
		pagination: {
			currentPage: 1,
			itemsPerPage: 10,
			totalResults: 40,
			numberOfPages: 4
		},
		hcpsPerPage: 0,
		isPaginationEnabled: true
	}),
	getters: {
		getIsEmpty: (state) => {
			return state.isEmpty;
		},
		getHcps: (state) => {
			return state.hcps;
		},
		getSortedHcps: (state) => {
			return state.sortedHcps;
		},
		getHcpsPagination: (state) => {
			return state.pagination;
		},
		getIsPaginationEnabled: (state) => {
			return state.isPaginationEnabled;
		}
	},
	mutations: {
		setIsEmpty: (state, status) => {
			state.isEmpty = status;
		},
		setHcps: (state, hcps) => {
			state.hcps = hcps
		},
		setOriginHcps: (state, hcps) => {
			state.originHcps = hcps
		},
		setSortedHcps: (state, sortedHcps) => {
			state.sortedHcps = sortedHcps
		},
		setHcpsPaginationCurrentPage: (state, page) => {
			state.pagination.currentPage = page;
		},
		setHcpsPagination: (state, total) => {
			state.pagination = {
				currentPage: 1,
				itemsPerPage: state.hcpsPerPage,
				totalResults: total,
				numberOfPages: Math.ceil(total/state.hcpsPerPage)
			}
		},
		setHcpsPerPage: (state, perPage) => {
			state.hcpsPerPage = perPage;
		},
		setIsPaginationEnabled: (state, status) => {
			state.isPaginationEnabled = status;
		}
	},
	actions: {
		fetchHcps: ({ commit, state, dispatch }) => {
			commit('setSpinnerIsShown', true, { root: true });

			const mocksApiUrl = `${state.apiUrl}?mocks=25`

			// axios.get(state.apiUrl)
			axios.get(mocksApiUrl)
				.then(({ data }) => {
					if (data) {
						commit('setIsEmpty', data.isEmpty);
						commit('setHcps', data.table.rows);
						commit('setOriginHcps', data.table.rows);

						if (!state.isPaginationEnabled) {
							commit('setHcpsPerPage', data.table.rows.length)
						}

						commit('setHcpsPaginationCurrentPage', 1);
						commit('setHcpsPagination', data.table.rows.length);
						dispatch('sortByAdded')
					}
				})
				.catch(error => {
					console.warn(error);
				})
				.finally(() => {
					commit('setSpinnerIsShown', false, { root: true });
				});
		},

		sortByAdded: ({ commit, state, dispatch }, sortOption) => {
			const sortedHcps = [...state.hcps].sort((a, b) => {
				const isoDateA = getIsoDate(a);
				const isoDateB = getIsoDate(b);

				if (isoDateA === null && isoDateB === null) return 0;
				if (isoDateA === null) return 1;
				if (isoDateB === null) return -1;

				if ( sortOption == "asc" ) {
					return isoDateA.localeCompare(isoDateB);
				} else {
					return isoDateB.localeCompare(isoDateA);
				}
			});
			commit('setSortedHcps', sortedHcps);
		},

		searchHcps: ({ commit, state, dispatch }, searchTerm) => {
			commit('setHcps', state.originHcps);
			if ( searchTerm !== "" ) {
				const searchResults = state.hcps.filter((hcp) => {
					const name = getName(hcp)

					return name.toLowerCase().includes(searchTerm.toLowerCase())
				});
				commit('setHcps', searchResults);
			}

			commit('setHcpsPaginationCurrentPage', 1);
			commit('setHcpsPagination', state.hcps.length);
			dispatch('sortByAdded')

		},
	}
}

const getIsoDate = (item) => {
	const addedColumn = item.values.find(val => val.columnKey === 'Added');
	return addedColumn ? addedColumn.valueInIso : null;
}

const getName = (item) => {
	const nameColumn = item.values.find(val => val.columnKey === 'Name');
	return nameColumn ? nameColumn.value : null;
}
